import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Row, Col, Alert, Card, CardBody, Container } from "reactstrap"

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation"

import { withRouter, Link } from "react-router-dom"

// import images
import logoSm from "../../assets/images/logo-sm.png"

import Authentication from "services/auth/Authentication.service"

const authService = new Authentication()

const Verify = props => {
  const verificationCode = props.location.search.split("=")[1]
  const [error, setError] = useState()
  const [success, setSuccess] = useState(false)

  useEffect(() => {}, [error])

  function handleValidSubmit(event, values) {
    authService.createPassword(values).then(res => {
      console.log(res)
      if (res.status) {
        setSuccess(true)
      } else {
        setError(res.message)
      }
    })
  }

  return (
    <React.Fragment>
      <MetaTags>
        <title>Reset Password | Staff</title>
      </MetaTags>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2"></i>
        </Link>
      </div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={4}>
              <Card className="overflow-hidden">
                <div className="bg-primary">
                  <div className="text-primary text-center p-4">
                    <h5 className="text-white font-size-20 p-2">
                      Set Password
                    </h5>
                    <a href="index.html" className="logo logo-admin">
                      <img src={logoSm} height="24" alt="logo" />
                    </a>
                  </div>
                </div>
                {success ? (
                  <CardBody className="p-4">
                    <Alert
                      color="success"
                      style={{ marginTop: "13px" }}
                      className="mt-5"
                    >
                      Password successfully set
                    </Alert>

                    <center>
                      <Link to="/login" className="fw-medium text-centerrimary">
                        {" "}
                        Click here to Login
                      </Link>{" "}
                    </center>
                  </CardBody>
                ) : (
                  <CardBody className="p-4">
                    {error && error ? (
                      <Alert
                        color="danger"
                        style={{ marginTop: "13px" }}
                        className="mt-5"
                      >
                        {error}
                      </Alert>
                    ) : null}

                    <AvForm
                      className="form-horizontal mt-4"
                      onValidSubmit={(e, v) => handleValidSubmit(e, v)}
                    >
                      <div className="mb-3">
                        <AvField
                          name="password"
                          label="Password"
                          className="form-control"
                          placeholder="Enter password"
                          type="password"
                          errorMessage="Password length should be 8 characters or more"
                          validate={{
                            required: { value: true },
                            minLength: {
                              value: 8,
                              errorMessage: "Min 8 characters.",
                            },
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="cpassword"
                          label="Confirm Password"
                          className="form-control"
                          placeholder="Confirm your password"
                          type="password"
                          errorMessage="Passwords do not match"
                          validate={{
                            required: { value: true },
                            match: { value: "password" },
                          }}
                        />
                      </div>
                      <div className="mb-3">
                        <AvField
                          name="verification_code"
                          type="hidden"
                          value={verificationCode}
                        />
                      </div>
                      <Row className="mb-3">
                        <Col className="text-end">
                          <button
                            className="btn btn-primary w-md waves-effect waves-light"
                            type="submit"
                          >
                            Set Password
                          </button>
                        </Col>
                      </Row>
                    </AvForm>
                  </CardBody>
                )}
              </Card>
              <div className="mt-5 text-center">
                <p>
                  © {new Date().getFullYear()} Rwanda Environment Management
                  Authority
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Verify
